module.exports = __webpack_public_path__ + "static/f20img1-a6d4f51e59ed5b5c89992132774123ba.jpg";